// constants/planDetails.ts

export interface PlanDetails {
  description: string;
  name: string;
  features: string[];
  icon: string;
  more: string;
  blueIcon: string;
  highlighted?: boolean;
}

export const PLAN_DETAILS: Record<string, PlanDetails> = {
  DEVICE_MANAGEMENT: {
    name: "Essentials",
    icon: "laptop-smartphone",
    blueIcon: "laptop-smartphone-blue",
    description:
      "For organizations that need reliable device lifecycle management without advanced security or conditional access controls.",
    more: "Provides core device, user, and policy management for day-to-day IT operations. Includes enrollment, software and policy control, remote actions, activity logging, and centralized administration to manage and support devices at scale.",
    features: [
      "Main admin dashboard & widgets",
      "Role-based admin access",
      "Geolocation services",
    ],
  },
  DEVICE_MANAGEMENT_AND_SECURITY: {
    icon: "shield-twotune",
    name: "Secure",
    blueIcon: "shield-twotune-blue",
    more: "Extends Essential with built-in security controls and visibility. Adds compliance policies, automated remediation, MFA configuration, patch and vulnerability management, and security posture dashboards to actively reduce risk and improve endpoint security. ",
    description:
      "For security-focused organizations that require compliance visibility, Zero Trust controls, and protection against unauthorized access.",
    features: [
      "Automated remediation",
      "Endpoint compliance policies",
      "MFA configuration (platform-wide)",
    ],
  },
  PLATFORM: {
    icon: "Box",
    name: "Zero Trust",
    more: "Delivers full platform capabilities with advanced access control. Enables conditional and context-aware access for devices and applications, device-level login enforcement, location-aware policies, and enhanced asset and fleet visibility for Zero Trust environments.",
    blueIcon: "Box-blue",
    description:
      "Complete access to device management, security, and Zero Trust capabilities for maximum control and protection.",
    features: [
      "Conditional access policies",
      "Device login for macOS & Windows",
      "Asset management",
    ],
    highlighted: true,
  },
};
